/*
 * @flow
 */
import { mapValues } from 'lodash';
import axios from 'axios';
import * as globals from '../constants/globals';
import {
  FETCH_PUBLIC_REVIEWS_FAILURE,
  FETCH_PUBLIC_REVIEWS_START,
  FETCH_PUBLIC_REVIEWS_SUCCESS,
  PUBLIC_REVIEWS_RESET,
} from '../constants/types';
import { generateErrorMessage } from '../utils/error';
import type { fetchPublicReviewsRequest } from '../model/publicReview';

export const fetchPublicReviewsEndpoint = (request: fetchPublicReviewsRequest, isLocationParent: boolean) => {
  const encoded = mapValues(request, encodeURIComponent);
  if (isLocationParent) {
    return `${globals.API_URL}/public?parent_location_id=${encoded.locationId}&parent_location_type=${encoded.locationType}&page_size=${request.pageSize}&sort_key=${encoded.sortKey}&start_key=${encoded.startKey}&rating=${encoded.rating}`;
  }
  return `${globals.API_URL}/public?location_id=${encoded.locationId}&location_type=${encoded.locationType}&page_size=${request.pageSize}&sort_key=${encoded.sortKey}&start_key=${encoded.startKey}&rating=${encoded.rating}`;
};

const fetchPublicReviewsApi = (request: fetchPublicReviewsRequest, isLocationParent: boolean = false) => () =>
  axios.get(fetchPublicReviewsEndpoint(request, isLocationParent), { headers: {} });

export function fetchPublicReviews(request: fetchPublicReviewsRequest, isParentLocation: boolean = false) {
  return async (dispatch: Function) => {
    dispatch({
      type: FETCH_PUBLIC_REVIEWS_START,
      payload: {
        location_id: request.locationId,
        location_type: request.locationType,
        pageSize: request.pageSize,
      },
    });

    try {
      const response = await dispatch(fetchPublicReviewsApi(request, isParentLocation));
      const responseData = response.data;

      dispatch({
        type: FETCH_PUBLIC_REVIEWS_SUCCESS,
        payload: {
          data: responseData.ratings,
          startKey: responseData.last_evaluated_key,
          location_id: request.locationId,
          location_type: request.locationType,
        },
      });

      return responseData;
    } catch (error) {
      const message = generateErrorMessage(error);
      dispatch({
        type: FETCH_PUBLIC_REVIEWS_FAILURE,
        payload: {
          error: message,
        },
      });
      throw new Error(message);
    }
  };
}

export const resetPublicReviews = (request: fetchPublicReviewsRequest, isParentLocation: boolean = false) => async (
  dispatch: Function
) => {
  dispatch({ type: PUBLIC_REVIEWS_RESET });

  return dispatch(fetchPublicReviews(request, isParentLocation));
};
